import { render, staticRenderFns } from "./step-personal-information.vue?vue&type=template&id=6449acf2&"
import script from "./step-personal-information.vue?vue&type=script&lang=js&"
export * from "./step-personal-information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports